import type {ActionResponse} from 'src/typings';
import {transferify} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {CreditTransfer, PayRequest} from './types';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class PaymentDataService {
    public static serviceName = 'paymentDataService';

    public static readonly ROUTE = 'payments/pay';
    public static readonly PAY_BY_CREDIT_ROUTE = 'payments/pay-by-credit';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async pay(payRequest: PayRequest): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(`${PaymentDataService.ROUTE}`)
            .post(transferify(payRequest));
    }

    @ngAsync()
    public async payByCredit(creditTransfer: CreditTransfer): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(`${PaymentDataService.PAY_BY_CREDIT_ROUTE}`)
            .post(transferify(creditTransfer));
    }
}
